import { type ReactNode } from 'react';
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormLabel as MuiFormLabel,
  Stack,
  StackProps,
} from '@mui/material';
import { MHMTypography, type MHMTypographyProps } from '../MHM/MHMTypography';

function Label({ ...rest }: StackProps) {
  return <Stack gap={1} {...rest} />;
}

type FormLabelProps = {
  label: ReactNode;
  labelProps?: MHMTypographyProps;
  required?: boolean;
  children?: ReactNode;
};

function FormLabel({ label, labelProps, required, children }: FormLabelProps) {
  return (
    <MuiFormLabel component={Label}>
      <MHMTypography {...labelProps}>
        {label} {required ? '*' : ''}
      </MHMTypography>
      {children}
    </MuiFormLabel>
  );
}

function FormGroup(props: StackProps) {
  return <Stack gap={2} {...props} />;
}

type LabelledCheckboxProps = CheckboxProps & {
  label: ReactNode;
  labelProps?: MHMTypographyProps;
};

function LabelledCheckbox({
  sx,
  label,
  labelProps,
  disabled,
  ...rest
}: LabelledCheckboxProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox disabled={disabled} sx={{ mt: -1, ...sx }} {...rest} />
      }
      label={<MHMTypography {...labelProps}>{label}</MHMTypography>}
      sx={{ alignItems: 'start' }}
      disabled={disabled}
    />
  );
}

export const AccountModal = {
  FormLabel,
  FormGroup,
  LabelledCheckbox,
};
